(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-js-home-about-video-section]';
    const videoSelector = '[data-js-home-about-video]';
    const sectionControllers = new WeakMap();

    function getSections(root = document) {
      if (root.matches?.(sectionSelector)) return [root];
      return [...root.querySelectorAll(sectionSelector)];
    }

    function ensureVideoSetup(video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
    }

    function initSection(section) {
      if (sectionControllers.has(section)) return;

      const video = section.querySelector(videoSelector);
      if (!video) return;

      ensureVideoSetup(video);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sectionControllers.set(section, { observer: null, video });
        return;
      }

      let userPaused = false;
      let isAutoPausing = false;

      function autoPause() {
        if (video.paused) return;
        isAutoPausing = true;
        video.pause();
      }

      function handlePause() {
        if (isAutoPausing) {
          isAutoPausing = false;
          return;
        }
        userPaused = true;
      }

      function handlePlay() {
        userPaused = false;
      }

      video.addEventListener('pause', handlePause);
      video.addEventListener('play', handlePlay);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== video) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              if (userPaused) return;
              const playAttempt = video.play();
              if (playAttempt && typeof playAttempt.catch === 'function') {
                playAttempt.catch(() => {});
              }
            } else {
              autoPause();
            }
          });
        },
        { threshold: [0, 0.55, 1] }
      );

      observer.observe(video);
      sectionControllers.set(section, { observer, video, handlePause, handlePlay });
    }

    function teardownSection(section) {
      const controller = sectionControllers.get(section);
      if (!controller) return;

      controller.observer?.disconnect();
      if (controller.video) {
        if (controller.handlePause) controller.video.removeEventListener('pause', controller.handlePause);
        if (controller.handlePlay) controller.video.removeEventListener('play', controller.handlePlay);
        controller.video.pause();
      }
      sectionControllers.delete(section);
    }

    function init(root = document) {
      getSections(root).forEach(initSection);
    }

    function teardown(root) {
      getSections(root).forEach(teardownSection);
    }

    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => teardown(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
